import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from '../../../config/endpoints.config';
import { resolve } from 'dns';

@Injectable({
  providedIn: 'root'
})
export class ScrPersonalInfService {
    constructor(private http: HttpClient) { }
    getPersonalInf() {
        return this.http.post<any>(EndpointsConfig.PersonalInf.getPersonalInf, null);
    }
    updPesonalInf(pParam) {
        return this.http.post<string>(EndpointsConfig.PersonalInf.updPesonalInf, pParam, {responseType: 'text' as 'json'});
    }
    checkEmail(pParam) {
        return this.http.post<string>(EndpointsConfig.PersonalInf.checkEmail, pParam, {responseType: 'text' as 'json'});
    }
    checkPass(pParam) {
        return this.http.post<string>(EndpointsConfig.PersonalInf.checkPass, pParam, {responseType: 'text' as 'json'});
    }
    checkUserResevation(){
        return this.http.post<string>(EndpointsConfig.PersonalInf.checkUserReservation, null, {responseType: 'text' as 'json'});
    }
}
